module.exports = __webpack_public_path__ + "media/images/avatar-undefined-90e232baf06d5c88212b72f2eaa30207.png";